module.exports = __webpack_public_path__ + "media/student_contributors/02FrancoCamacho-b6e772ad.png";